import { ItemType } from "../types/enums";
import { Order, Product } from "../types/interfaces";
import {
  HooksAndOptionsMappedValues,
  ProsthesisMappedValues,
  InformationMappedValues,
  savePartialDenture,
} from "./partialDentureUpdate";

export type PatientFormValues = Record<string, unknown> & {
  doctorId: string;
  firstName: string;
  lastName: string;
  birthDate: number;
  sex: string;
};

export const updatePatient = async (
  updateOrder: (data: { variables: any }) => Promise<Order>,
  mappedValues: PatientFormValues,
  orderId: string
) => {
  try {
    return await updateOrder({
      variables: {
        data: {
          user: {
            connect: {
              id: mappedValues.doctorId,
            },
          },
          patient: {
            create: {
              firstName: mappedValues.firstName,
              lastName: mappedValues.lastName,
              birthdate: mappedValues.birthDate,
              sex: mappedValues.sex,
              dentist: {
                connect: {
                  id: mappedValues.doctorId,
                },
              },
            },
          },
        },
        where: {
          id: orderId,
        },
      },
    });
  } catch (error) {
    console.error("Failed to update patient:", error);
    throw error;
  }
};

export const updateProduct = async (
  updateOrder: (data: { variables: any }) => Promise<Order>,
  mappedValues:
    | InformationMappedValues
    | ProsthesisMappedValues
    | HooksAndOptionsMappedValues,
  orderId: string,
  currentProduct: ItemType,
  currentStepLabel: string,
  product: Product
) => {
  try {
    const normalizedProduct = (currentProduct as string).split(" ")[0];

    switch (normalizedProduct) {
      case ItemType.PARTIAL_DENTURE:
        return savePartialDenture(
          updateOrder,
          mappedValues,
          orderId,
          currentStepLabel,
          product
        );
      case ItemType.FULL_DENTURE:
        return true;
      default:
        console.warn(
          `Product type "${currentProduct}" not handled for product update.`
        );
    }
  } catch (error) {
    console.error("Failed to update product:", error);
    throw error;
  }
};
